export { AccommodationGallery as default } from './accommodation-gallery';
export * from './accommodation-gallery';
